module.exports = __webpack_public_path__ + "static/img/payment-creditCard.4203e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-creditCard.png
// module id = Agg6
// module chunks = 0